"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonStyles = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var buttonStyles = function buttonStyles(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-flex;align-items:center;justify-content:center;min-height:14px;cursor:", props.disabled ? 'not-allowed' : 'pointer', ";background-color:transparent;border:none;outline:none;padding:0px;font-family:inherit;font-size:", props.size === 'small' ? '14px' : '16px', ";font-weight:400;text-decoration:none;transition:all 0.25s ease-in-out;opacity:", props.disabled ? props.theme.disabledOpacity : 1, ";color:", props.textColor, ";fill:", props.iconFill, ";&:hover{color:", props.hoverTextColor && !props.disabled ? props.hoverTextColor : undefined, ";fill:", props.hoverIconFill && !props.disabled ? props.hoverIconFill : undefined, ";}&:active{color:", props.clickedTextColor && !props.disabled ? props.clickedTextColor : undefined, ";fill:", props.clickedIconFill && !props.disabled ? props.clickedIconFill : undefined, ";}")
  );
};

exports.buttonStyles = buttonStyles;

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("button", {
  target: "css-hux0ay0"
})(buttonStyles, ";"));

exports.default = _default;